/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import SettlementTable from "./settlementTable";
// import classes from "../reports.module.css";
import classes from "../../orders/orders.module.css";
import moment from "moment";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  DetailView,
  ListView,
  UsersIcon,
  InvoiceView,
  ViewIconNew,
  InvoicePaid
} from "../../../../component/icons/icons";
import { withTranslation } from "react-i18next";
import { Grid, Select, FormControl, InputLabel } from "@mui/material";
import dateFormat from "dateformat";
import Button from "../../../../component/button";
import { ButtonGroup } from "@mui/material";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import TableContainer from "@mui/material/TableContainer";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { formatNumber } from "../../../../helper/numberFormatter";
import {formatDate, isValidDate, convertDateParam, convertTillDateParam} from "../../../../helper/dateFormatter";
import Base64ViewerDialog from "../../../../component/fileViewer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";

class Settlement extends Component {
  // Declare property values that belongs to the component
  state = {
    tabValue: 0,
    settlementList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalSettlementCount: 0,
    sortBy: "invoiceDate",
    sortOrder: "DESC",
    customerBan: "",
    customerName: "",
    orderId: "",
    itemDescription: "",
    solutionProviderName: "",

    fromDate: "",
    toDate: "",
    status: 'ALL',

    purchasePrice: 0,
    sellingPrice: 0,
    settledAmount: 0,
    bread: [{ title: this.props.t("SETTLEMENT"), url: "/settlement" }],
    today: moment(new Date()).format("yyyy-MM-DD"),
    isMobile: false,
    settlementsView: null,
    showLoading: false,

    tenantList: [],
    tenant: "",

    testInvoiceData: [{ "orderId": "SOI7575049", "invoiceId": "13082", "invoiceDate": "22-Dec-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 11.46, "status": "Unpaid" }, { "orderId": "SOI7577140", "invoiceId": "13040", "invoiceDate": "19-Dec-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 83.47, "status": "Unpaid" }, { "orderId": "SOI7573489", "invoiceId": "13008", "invoiceDate": "18-Dec-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 38.25, "status": "Unpaid" }, { "orderId": "SOI7573880", "invoiceId": "12951", "invoiceDate": "09-Dec-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 23.34, "status": "Unpaid" }, { "orderId": "SOI7572729", "invoiceId": "12938", "invoiceDate": "05-Dec-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 24.13, "status": "Unpaid" }, { "orderId": "SOI7574329", "invoiceId": "12862", "invoiceDate": "29-Nov-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 11.46, "status": "Unpaid" }, { "orderId": "SOI7575049", "invoiceId": "12734", "invoiceDate": "22-Nov-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 11.46, "status": "Unpaid" }, { "orderId": "SOI7573489", "invoiceId": "12691", "invoiceDate": "20-Nov-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 38.25, "status": "Unpaid" }, { "orderId": "SOI7573880", "invoiceId": "12667", "invoiceDate": "09-Nov-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 23.34, "status": "Unpaid" }, { "orderId": "SOI7572729", "invoiceId": "12622", "invoiceDate": "05-Nov-2025", "currency": "Kuwaiti Dinar", "totalInvoiceAmount": 24.13, "status": "Unpaid" }],
    invoiceList: [],
    totalInvoiceCount: 0,
    invoiceHistoryPage: 1,
    invoiceHistoryPerPage: 10,
    invoiceHistoryStartRecord: 1,
    sortOrderInvoice: "DESC",
    sortByInvoice: "invoiceDate",

    monthsList: Array.from({ length: 12 }, (_, i) => {
      const month = String(i + 1).padStart(2, "0");
      return { month };
    }),
    currentYear: new Date().getFullYear(),
    yearsList: Array.from(
      { length: (new Date().getFullYear()) - 2020 + 1 },
      (_, i) => {
        const year = 2020 + i;
        return { year };
      }
    ),

    invoiceId: '',
    month: String(new Date().getMonth() + 1).padStart(2, "0"),
    year: new Date().getFullYear(),

    opcoList: [],
    partnerList: [],

    tabValue: 1,
    partnerId: 'all',

    selectedFileToView: {},
    showFileData: false,

    invoiceToUpdate: {},
    showConfirmationDialog: false,

    // Bill view filters
    invoiceStatus: 'ALL',
    invoiceToDate: '',
    invoiceFromDate: '',
    invoiceAmount: '',
    invoiceId: '',

    invoiceSortBy: 'invoiceDate',
    invoiceSortOrder: 'DESC',

    productName: '',
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();

    const settlementsView = localStorage.getItem("settlementsView");

    if (this.props.providerType === "SOLUTION_PROVIDER") {
      // Get OPCO list for solution provider/partner
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
        {},
      )
        .then((res) => {
          let list = res.data.tenants.sort((a, b) =>
            a.tenantName.localeCompare(b.tenantName, undefined, { sensitivity: "base" })
          );
          var selectedSalesChannel = localStorage.getItem(
            "selectedSalesChannel",
          );
          this.setState(
            {
              tenantList: list,
              tenant:
                this.props.parentTenantId ||
                selectedSalesChannel ||
                (list && list.length > 0 ? list[0].tenantId : ""),
            },
            () => {
              localStorage.setItem(
                "selectedSalesChannel",
                this.state.tenant,
              );

              if (settlementsView === null) {
                this.setState({
                  settlementsView: 'invoice'
                });
                this.getInvoices();
              } else {
                this.setState({
                  settlementsView
                });
                if (settlementsView === 'list') {
                  this.getSettlements();
                }
              }

            },
          );
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.message
          ) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else if (this.props.providerType === "SALES_CHNL_PROVIDER") {
      this.setState({ loading: true });

      Promise.all([
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/passthru/GET_ASSOC_PARTNERS/endpoint`,
          {}
        ),
        BusApiCall(
          "GET",
          `${constants.busInternalUrl}/passthru/GET_OPCO_LIST/endpoint`,
          {}
        )
      ])
        .then(([partnerRes, opcoRes]) => {
          const partnerList = partnerRes?.data?.list || [];
          var opcoList = opcoRes?.data?.tenants.sort((a, b) =>
            a.tenantName.localeCompare(b.tenantName, undefined, { sensitivity: "base" })
          ) || [];

          this.setState({
            partnerList: partnerList.sort((a, b) =>
              a.groupName.localeCompare(b.groupName, undefined, { sensitivity: "base" })
            ),
            opcoList: opcoList,
            // partnerId: partnerList.length > 0 ? partnerList[0].id : null,
            // partnerId: 'all',
            tenant: opcoList.length > 0 ? opcoList[0].tenantId : null,
          }, () => {
            if (settlementsView === null) {
              this.setState({
                settlementsView: 'invoice',
                loading: false,
              });
              this.getInvoices();
            } else {
              this.setState({
                settlementsView,
                loading: false,
              });
              if (settlementsView === 'invoice') {
                this.getInvoices();
              }
              if (settlementsView === 'list') {
                this.getSettlements();
              }
            }
          });
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false
            );
          }
          this.setState({ loading: false });
        });

    } else {
      if (settlementsView === null) {
        this.setState({
          settlementsView: 'invoice',
          loading: false,
        });
      } else {
        this.setState({
          settlementsView,
          loading: false,
        });
        if (settlementsView === 'invoice') {
          this.getInvoices();
        }
        if (settlementsView === 'list') {
          this.getSettlements();
        }
      }
    }
  }

  getInvoices = () => {
    this.setState({
      loading: true,
      invoiceList: [],
      totalInvoiceCount: 0
    });
    let pageOptions = {
      batchSize: this.state.invoiceHistoryPerPage || 10,
      startRecord: this.state.invoiceHistoryStartRecord || 1,
    };
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.state.tenant;
    }
    if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
      jsonData.tenantId = this.state.tenant;
    }

    // var filters = `&month=${this.state.month}&year=${this.state.year}&saveInvoice=false`;
    var filters = `&saveInvoice=false`;
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      filters += `&invoiceTypeId=PARTNER_STLMNT_INV`;
    }
    if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
      if (this.state.tabValue === 2) {
        filters += `&invoiceTypeId=GROUP_STLMNT_INV`;
      } else {
        filters += `&invoiceTypeId=PARTNER_STLMNT_INV`;
      }
    } else {
      if (this.props.providerType === "SALES_CHNL_PROVIDER") {
        filters += `&invoiceTypeId=GROUP_STLMNT_INV`;
      }
    }
    if (this.state.invoiceId) {
      filters += `&invoiceId=${this.state.invoiceId}`;
    }
    if (this.state.partnerId) {
      filters += `&partnerId=${this.state.partnerId}`;
    }
    if (this.state.invoiceStatus && this.state.invoiceStatus !== 'ALL') {
      filters += `&status=${this.state.invoiceStatus}`;
    }

    let invoiceFromDate = this.state.invoiceFromDate
      ? encodeURIComponent(this.convertDateParam(this.state.invoiceFromDate))
      : "";
    let invoiceToDate = this.state.invoiceToDate
      ? encodeURIComponent(this.convertTillDateParam(this.state.invoiceToDate))
      : "";

    if (this.state.invoiceToDate) {
      filters += `&to=${invoiceToDate}`;
    }
    if (this.state.invoiceFromDate) {
      filters += `&from=${invoiceFromDate}`;
    }
    if (this.state.invoiceAmount) {
      filters += `&amount=${this.state.invoiceAmount}`;
    }

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/providers/${this.state.tenant ? this.state.tenant : this.props.providerId}/settlement-invoices?sortBy=${this.state.invoiceSortBy}&sortOrder=${this.state.invoiceSortOrder}${filters}`,
      jsonData,
      pageOptions,
    ).then((res) => {
      this.setState({
        invoiceList: res.data || [],
        totalInvoiceCount: +res.headers["x-total-count"],
        loading: false
      })
    })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          invoiceList: [],
          totalInvoiceCount: 0,
          loading: false
        })
      });
  }

  generateInvoices = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.invoiceRowPerPage || 10,
      startRecord: this.state.invoicesStartRecord || 1,
    };
    let jsonData = {
      saveInvoice: false,
      month: this.state.month,
      year: '' + this.state.year,
      partnerPartyId: this.state.partnerId !== 'all' ? this.state.partnerId : null
    };
    if (this.props.providerType === "SOLUTION_PROVIDER" || (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER"))) {
      jsonData.tenantId = this.state.tenant;
    } else {
      jsonData.tenantId = this.props.providerId;
    }
    // if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
    //   jsonData.tenantId = this.state.tenant;
    // }
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.invoiceTypeId = `PARTNER_STLMNT_INV`;
    }
    if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
      if (this.state.tabValue === 2) {
        jsonData.invoiceTypeId = `GROUP_STLMNT_INV`;
      } else {
        jsonData.invoiceTypeId = `PARTNER_STLMNT_INV`;
      }
    } else {
      if (this.props.providerType === "SALES_CHNL_PROVIDER") {
        jsonData.invoiceTypeId = `GROUP_STLMNT_INV`;
      }
    }
    BusApiCall(
      "POST",
      `${constants.busV44UrlPublic}/providers/${this.state.tenant ? this.state.tenant : this.props.providerId}/settlement-invoices`,
      jsonData,
      pageOptions,
    ).then((res) => {
      // Convert pdf to array buffer
      var arrrayBuffer = this.base64ToArrayBuffer(res.data.invoicePdf);
      // Create pdf blob
      var blob = new Blob(
        [arrrayBuffer],
        { type: "application/pdf" },
        "upcoming-bill.pdf",
      );
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.href = url;
      link.download = "upcoming-bill.pdf";
      link.dispatchEvent(new MouseEvent("click"));
      this.setState({ loading: false });
    })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  }

  getSettlements = () => {
    this.setState({
      loading: true,
      settlementList: [],
      totalSettlementCount: 0
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER" || (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER"))) {
      jsonData.tenantId = this.state.tenant;
    }
    let fromDate = this.state.fromDate
      ? encodeURIComponent(convertDateParam(this.state.fromDate))
      : "";
    let toDate = this.state.toDate
      ? encodeURIComponent(convertTillDateParam(this.state.toDate))
      : "";

    let searchFilter = `partnerId=${this.state.partnerId}&customerBan=${this.state.customerBan}&customerName=${this.state.customerName}&orderId=${this.state.orderId}&productName=${this.state.productName}&from=${fromDate}&to=${toDate}&status=${this.state.status === 'ALL' ? '' : this.state.status}&invoiceId=${this.state.invoiceId}`;
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      searchFilter += `&invoiceTypeId=PARTNER_STLMNT_INV`;
    }
    if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
      if (this.state.tabValue === 2) {
        searchFilter += `&invoiceTypeId=GROUP_STLMNT_INV`;
      } else {
        searchFilter += `&invoiceTypeId=PARTNER_STLMNT_INV`;
      }
    } else {
      if (this.props.providerType === "SALES_CHNL_PROVIDER") {
        searchFilter += `&invoiceTypeId=GROUP_STLMNT_INV`;
      }
    }
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/providers/${this.state.tenant ? this.state.tenant : this.props.providerId}/settlement-invoices/report?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&${searchFilter}`,
      jsonData,
      pageOptions,
    )
      .then((res) => {
        //let data = JSON.parse(res);
        this.setState({
          settlementList: res.data || [],
          totalSettlementCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          settlementList: [],
          totalSettlementCount: 0
        });
      });
  };

  // Covert base64 to array buffer
  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  // convertDate(date) {
  //   return moment(date).format("MM/DD/YYYY, h:mm a");
  // }

  // convertDateParam(date) {
  //   return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  // }

  // convertTillDateParam(date) {
  //   return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  // }

  prependZero(numToChange) {
    var retNum = parseInt(numToChange);
    retNum = retNum < 10 ? "0" + retNum : retNum;
    return retNum;
  }

  // isValidDate(dateString) {
  //   if (!dateString) {
  //     return true;
  //   }
  //   // First check for the pattern
  //   if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

  //   // Parse the date parts to integers
  //   var parts = dateString.split("/");
  //   var day = parseInt(parts[1], 10);
  //   var month = parseInt(parts[0], 10);
  //   var year = parseInt(parts[2], 10);

  //   // Check the ranges of month and year
  //   if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

  //   var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  //   // Adjust for leap years
  //   if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
  //     monthLength[1] = 29;

  //   // Check the range of the day
  //   return day > 0 && day <= monthLength[month - 1];
  // }

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getSettlements();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getSettlements();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        productName: '',
        toDate: '',
        fromDate: '',
        customerBan: '',
        customerName: '',
        invoiceId: '',
        orderId: '',
        page: 1,
        startRecord: 1,
        partnerId: 'all',
        status: 'ALL'
      },
      () => {
        this.getSettlements();
      },
    );
  };

  refreshTableSearch = () => {
    this.setState(
      {
        customerBan: "",
        customerName: "",
        orderId: "",
        itemDescription: "",
        solutionProviderName: "",
        fromDate: "",
        toDate: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  onInvoiceHistoryPageChange = (e, page) => {
    this.setState(
      {
        loading: true,
        invoiceHistoryPage: page,
        invoiceHistoryStartRecord: this.state.invoiceHistoryPerPage * (page - 1) + 1,
      },
      () => {
        this.getInvoices();
      },
    );
  };

  updateInvoiceHistoryPerPageRows = (event) => {
    this.setState(
      {
        loading: true,
        invoiceHistoryPage: 1,
        invoiceHistoryPerPage: event.target.value,
        invoiceHistoryStartRecord: 1,
      },
      () => {
        this.getInvoices();
      },
    );
  };

  toggleShowAllSettlements = (viewType) => {
    localStorage.setItem("settlementsView", viewType);
    this.setState({
      settlementsView: viewType
    })
    if (viewType === 'list') {
      this.getSettlements();
    }
    if (viewType === 'invoice') {
      this.getInvoices();
    }
  };

  onInvoiceChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  onInvoiceSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getInvoices();
    }
  }

  filterInvoiceTable = () => {
    this.getInvoices();
  }

  clearInvoiceTableSearch = () => {
    this.setState({
      invoiceHistoryPage: 1,
      month: String(new Date().getMonth() + 1).padStart(2, "0"),
      year: new Date().getFullYear(),
      invoiceStatus: 'ALL',
      invoiceToDate: '',
      invoiceFromDate: '',
      invoiceAmount: '',
      invoiceId: '',
      partnerId: 'all',
    }, () => {
      this.getInvoices();
    })
  }

  updateInvoiceSorting = (by) => {
    if (by === this.state.invoiceSortBy) {
      this.setState(
        {
          invoiceSortOrder: this.state.invoiceSortOrder === "DESC" ? "ASC" : "DESC",
          invoiceHistoryPage: 1,
          invoiceHistoryStartRecord: 1,
        },
        () => {
          this.getInvoices();
        },
      );
    } else {
      this.setState(
        {
          invoiceSortBy: by,
          invoiceSortOrder: "ASC",
          invoiceHistoryPage: 1,
          invoiceHistoryStartRecord: 1,
        },
        () => {
          this.getInvoices();
        },
      );
    }
  }

  changeGroupView = (e, newValue) => {
    this.setState({
      tabValue: newValue
    }, () => {
      if (this.state.settlementsView === 'list') {
        this.getSettlements();
      } else if (this.state.settlementsView === 'invoice') {
        this.getInvoices();
      } else {
        this.setState({
          settlementsView: null
        }, () => {
          this.setState({
            settlementsView: 'detail'
          })
        })
      }
    });
  }

  downloadInvoicePdf = (invoiceId, type) => {
    this.setState({
      loading: true,
    });

    var jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER" || (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER"))) {
      jsonData.tenantId = this.state.tenant;
    }
    // else {
    //   jsonData.tenantId = this.props.providerId;
    // }

    // Get PDF link
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/providers/${this.state.tenant ? this.state.tenant : this.props.providerId}/settlement-invoices/${invoiceId}/download`, jsonData
    )
      .then((res) => {
        this.setState({
          loading: false,
        });
        console.log("check original response", res.data);

        if (type && type === "view") {
          this.setState({
            selectedFileToView: {
              base64: res.data.invoicePdf,
              mimeType: "application/pdf",
              name: invoiceId,
            },
            showFileData: true,
          });
        } else {
          // Convert pdf to array buffer
          var arrrayBuffer = this.base64ToArrayBuffer(res.data.invoicePdf);
          // Create pdf blob
          var blob = new Blob(
            [arrrayBuffer],
            { type: "application/pdf" },
            invoiceId + "-bill.pdf",
          );
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = url;
          link.download = invoiceId + "-bill.pdf";
          link.dispatchEvent(new MouseEvent("click"));
          // Create URL object and download
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  updateInvoiceStatus = (invoice) => {
    this.setState({
      invoiceToUpdate: invoice,
      showConfirmationDialog: true
    })
  }

  closeConfirmDialog = (val) => {
    if (val && this.state.tenant) {
      this.setState({
        loading: true
      })
      var payload = {
        userName: this.props.loggedInUserName
          ? this.props.loggedInUserName
          : this.props.providerName,
        userLoginId: this.props.loggedInUserId,
        status: 'INVOICE_PAID',
        tenantId: this.state.tenant
      };
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/providers/${this.state.tenant}/settlement-invoices/${this.state.invoiceToUpdate.invoiceId}`,
        payload,
      ).then((res) => {
        this.props.setErrorMessage(this.props.t("BILL_STATUS_UPDATED_SUCCESSFULLY"), true);
        this.setState({
          invoiceToUpdate: {},
          showConfirmationDialog: false
        })
        this.getInvoices();
      }).catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          invoiceToUpdate: {},
          showConfirmationDialog: false,
          loading: false
        })
      });
    } else {
      this.setState({
        invoiceToUpdate: {},
        showConfirmationDialog: false
      })
    }
  }

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  // Render order view
  render() {
    const t = this.props.t;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ marginTop: "0px" }}>
          <div>
            {this.props.providerType === "SALES_CHNL_PROVIDER" &&
              this.props.tenantRoles.includes("MASTER_PROVIDER") && (
                <Tabs
                  indicatorColor="primary"
                  onChange={this.changeGroupView}
                  value={this.state.tabValue}
                  style={{ padding: "0" }}
                  className={classes.createPackageComponentTabs}
                >
                  <Tab value={1} label={t("AMOUNT_PAYABLE_TO_PARTNER")} />
                  <Tab value={2} label={t("AMOUNT_RECEIVABLE_TO_OPCO")} />
                </Tabs>
              )}
          </div>
          <Grid container spacing={1}>
            <Grid
              item
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "flex-end",
                marginBottom: "1rem",
              }}
              size={{
                xs: 12,
                md: 12,
              }}
            >

              {isMobile && (
                <Button
                  className="buttonSecondary"
                  onClick={this.toggleShowCustomerList}
                >
                  <span
                    style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                  >
                    <UsersIcon />
                  </span>
                  {t("SHOW_CUSTOMER_LIST")}
                </Button>
              )}
              <ButtonGroup variant="outlined">
                {/* INVOICE view button */}
                <span
                  className={`buttonGroup ${this.state.settlementsView === 'invoice' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllSettlements("invoice")}
                  style={{
                    backgroundColor: this.state.settlementsView === 'invoice'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.settlementsView === 'invoice' ? "white" : "inherit",
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("INVOICES")}
                  </span>
                  <InvoiceView />
                </span>
                {/* DETAIL VIEW button */}
                {/* <span
                  className={`buttonGroup ${this.state.settlementsView === 'detail' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllSettlements("detail")}
                  style={{
                    backgroundColor: this.state.settlementsView === 'detail'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.settlementsView === 'detail' ? "white" : "inherit",
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("DETAIL_VIEW")}
                  </span>
                  <DetailView />
                </span> */}
                {/* LIST VIEW button */}
                <span
                  className={`buttonGroup ${this.state.settlementsView === 'list' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllSettlements("list")}
                  style={{
                    backgroundColor: this.state.settlementsView === 'list'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.settlementsView === 'list' ? "white" : "inherit",
                  }}
                >
                  <span>{this.props.t("INVOICES_BREAKDOWN")}</span>
                  <ListView />
                </span>
              </ButtonGroup>
            </Grid>
          </Grid>

          {this.state.settlementsView === 'detail' ?
            <ManageCustomersHierarchy
              screen="settlementView"
              userId={this.state.userId}
              onRef={(ref) => (this.hierarchyRef = ref)}
              isMobile={isMobile}
              showCustomerList={showCustomerList}
              toggleShowCustomerList={this.toggleShowAllSettlements}
              controls={this.state.controls}
              loggedInUserType={this.props.loggedInUserType}
              providerType={this.props.providerType}
              showLoading={this.state.showLoading}
              // orderStatus={this.state.orderStatus}
              statusList={this.state.statusList}
              // onChange={this.onChange}
              // onSearchKeyDown={this.onSearchKeyDown}
              // tenant={this.state.tenant}
              // tenantList={this.state.tenantList}
              // filterOrderTable={this.filterOrderTable}
              // clearOrderTableSearch={this.clearOrderTableSearch}
              // refreshOrderTableSearch={this.refreshOrderTableSearch}
              // parentTenantId={this.state.tenant}
              setErrorMessage={this.props.setErrorMessage}
              partnerList={this.state.partnerList}
              tabValue={this.state.tabValue}
            />
            : this.state.settlementsView === 'invoice' ?
              <>
                <Paper
                  className={"tablePaper"}
                  elevation={0}
                  style={{ borderRadius: "8px", background: 'white', border: '1px solid lightgrey' }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        textAlign: "right",
                        width: "100%"
                      }}
                    >
                      {/* ===== LEFT SIDE (Tabs) ===== */}
                      <div style={{ float: 'left', textAlign: 'left' }}>
                        {this.state.tabValue === 1 &&
                          <>
                            {this.props.providerType === "SOLUTION_PROVIDER" ?
                              <h3 style={{ margin: 0 }}>
                                Bills Summary&nbsp;
                                <Tooltip title={'Bills issued to group for selected period.'}>
                                  <svg
                                    width="18"
                                    height="18"
                                    style={{ position: 'relative', top: '5px' }}
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_380_7010)">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                        fill="#96A1B0"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_380_7010">
                                        <rect
                                          width="12"
                                          height="12"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </Tooltip>
                              </h3>
                              :
                              this.props.tenantRoles.includes("MASTER_PROVIDER") ?
                                <h3 style={{ margin: 0 }}>
                                  Partner Bills (Bills Summary)&nbsp;
                                  <Tooltip title={'Bills received from partners for the selected period.'}>
                                    <svg
                                      width="18"
                                      height="18"
                                      style={{ position: 'relative', top: '5px' }}
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clipPath="url(#clip0_380_7010)">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                          fill="#96A1B0"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_380_7010">
                                          <rect
                                            width="12"
                                            height="12"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </Tooltip>
                                </h3>
                                :
                                <h3 style={{ margin: 0 }}>
                                  Bills Summary&nbsp;
                                  <Tooltip title={'Bills received from group for the selected period.'}>
                                    <svg
                                      width="18"
                                      height="18"
                                      style={{ position: 'relative', top: '5px' }}
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clipPath="url(#clip0_380_7010)">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                          fill="#96A1B0"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_380_7010">
                                          <rect
                                            width="12"
                                            height="12"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </Tooltip>
                                </h3>
                            }
                          </>
                        }
                        {this.state.tabValue === 2 &&
                          <>
                            <h3 style={{ margin: 0 }}>
                              OpCo Bills (Bills Summary)&nbsp;
                              <Tooltip title={'Bills issued to OpCos for the selected period.'}>
                                <svg
                                  width="18"
                                  height="18"
                                  style={{ position: 'relative', top: '5px' }}
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_380_7010)">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                      fill="#96A1B0"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_380_7010">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </Tooltip>
                            </h3>
                          </>
                        }
                      </div>
                      {/* ===== RIGHT SIDE (Search / Filters) ===== */}
                      <div style={{ marginBottom: '15px', float: 'right' }}>
                        {/* {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                          this.props.tenantRoles.includes("MASTER_PROVIDER") &&
                          <Button
                            onClick={this.generateInvoices}
                            style={{ height: "35.59px" }}
                          >
                            {t('UPCOMING_INVOICES')}
                          </Button>
                        } */}
                        {/* {this.props.providerType === "SOLUTION_PROVIDER" && */}
                        <Tooltip 
                          title={this.state.partnerId === 'all' ? t('SELECT_SPECIFIC_PARTNER') : ''}
                          arrow
                        >
                          <span>
                            <Button
                              onClick={this.generateInvoices}
                              style={{ height: "35.59px" }}
                              disabled={this.state.partnerId === 'all' && this.props.providerType === "SALES_CHNL_PROVIDER"}
                            >
                              {t('UPCOMING_INVOICES')}
                            </Button>
                          </span>
                        </Tooltip>
                        {/* } */}
                      </div>
                      <div style={{ clear: 'both' }}></div>
                    </div>

                    <div>
                      <div style={{ marginBottom: ".5rem" }}>
                        <div className={classes.searchOuterDiv}>
                          {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                            this.props.tenantRoles.includes("MASTER_PROVIDER") && this.state.tabValue === 2 && (
                              <>
                                <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                                  <FormControl
                                    variant="outlined"
                                    size="small"
                                    style={{ width: "173px" }}
                                  >
                                    <InputLabel htmlFor="outlined-native-tenant">
                                      {t("OPCO")}
                                    </InputLabel>

                                    <Select
                                      native
                                      name="tenant"
                                      value={this.state.tenant}
                                      onChange={this.onInvoiceChange}
                                      onKeyDown={this.onInvoiceSearchKeyDown}
                                      inputProps={{
                                        id: "outlined-native-tenant",
                                      }}
                                      label={t("OPCO")}

                                    >
                                      {this.state.opcoList.map((a) => (
                                        <option key={a.tenantId} value={a.tenantId}>
                                          {a.tenantName}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </div>
                                <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                                  <FormControl
                                    variant="outlined"
                                    size="small"
                                    style={{ width: "173px" }}
                                  >
                                    <InputLabel htmlFor="outlined-native-partnerId">
                                      {t('PARTNER')}
                                    </InputLabel>

                                    <Select
                                      native
                                      name="partnerId"
                                      value={this.state.partnerId}
                                      onChange={this.onInvoiceChange}
                                      onKeyDown={this.onInvoiceSearchKeyDown}
                                      inputProps={{
                                        id: "outlined-native-partnerId",
                                      }}
                                      label={t('PARTNER')}

                                    >
                                      <option value={'all'}>
                                        {t('ALL')}
                                      </option>
                                      {this.state.partnerList.map((a) => (
                                        <option key={a.id} value={a.id}>
                                          {a.groupName}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </div>
                              </>
                            )}

                          {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                            this.props.tenantRoles.includes("MASTER_PROVIDER") && this.state.tabValue === 1 && (
                              <>
                                <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                                  <FormControl
                                    variant="outlined"
                                    size="small"
                                    style={{ width: "173px" }}
                                  >
                                    <InputLabel htmlFor="outlined-native-partnerId">
                                      {t('PARTNER')}
                                    </InputLabel>

                                    <Select
                                      native
                                      name="partnerId"
                                      value={this.state.partnerId}
                                      onChange={this.onInvoiceChange}
                                      onKeyDown={this.onInvoiceSearchKeyDown}
                                      inputProps={{
                                        id: "outlined-native-partnerId",
                                      }}
                                      label={t('PARTNER')}

                                    >
                                      <option value={'all'}>
                                        {t('ALL')}
                                      </option>
                                      {this.state.partnerList.map((a) => (
                                        <option key={a.id} value={a.id}>
                                          {a.groupName}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </div>
                                <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                                  <FormControl
                                    variant="outlined"
                                    size="small"
                                    style={{ width: "173px" }}
                                  >
                                    <InputLabel htmlFor="outlined-native-tenant">
                                      {t("OPCO")}
                                    </InputLabel>

                                    <Select
                                      native
                                      name="tenant"
                                      value={this.state.tenant}
                                      onChange={this.onInvoiceChange}
                                      onKeyDown={this.onInvoiceSearchKeyDown}
                                      inputProps={{
                                        id: "outlined-native-tenant",
                                      }}
                                      label={t("OPCO")}

                                    >
                                      {this.state.opcoList.map((a) => (
                                        <option key={a.tenantId} value={a.tenantId}>
                                          {a.tenantName}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </div>
                              </>
                            )}

                          {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                            !this.props.tenantRoles.includes("MASTER_PROVIDER") &&
                            (
                              <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  style={{ width: "173px" }}
                                >
                                  <InputLabel htmlFor="outlined-native-partnerId">
                                    {t('PARTNER')}
                                  </InputLabel>

                                  <Select
                                    native
                                    name="partnerId"
                                    value={this.state.partnerId}
                                    onChange={this.onInvoiceChange}
                                    onKeyDown={this.onInvoiceSearchKeyDown}
                                    inputProps={{
                                      id: "outlined-native-partnerId",
                                    }}
                                    label={t('PARTNER')}

                                  >
                                    <option value={'all'}>
                                      {t('ALL')}
                                    </option>
                                    {this.state.partnerList.map((a) => (
                                      <option key={a.id} value={a.id}>
                                        {a.groupName}
                                      </option>
                                    ))}
                                  </Select>
                                </FormControl>

                              </div>
                            )}

                          {this.props.providerType === "SOLUTION_PROVIDER" && (
                            <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                              <FormControl
                                variant="outlined"
                                size="small"
                                style={{ width: "173px" }}
                              >
                                <InputLabel htmlFor="outlined-native-tenant">
                                  {t('OPCO')} &nbsp;
                                </InputLabel>

                                <Select
                                  native
                                  name="tenant"
                                  value={this.state.tenant}
                                  onChange={this.onInvoiceChange}
                                  onKeyDown={this.onInvoiceSearchKeyDown}
                                  inputProps={{
                                    id: "outlined-native-tenant",
                                  }}
                                  label={t('OPCO')}

                                >
                                  {this.state.tenantList.map((a) => (
                                    <option key={a.tenantId} value={a.tenantId}>
                                      {a.tenantName}
                                    </option>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          )}
                          {/* <div className={classes.searchInputDiv}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "173px" }}
                            >
                              <InputLabel htmlFor="outlined-native-month">
                                {t('SELECT_MONTH')}
                              </InputLabel>

                              <Select
                                native
                                name="month"
                                value={this.state.month}
                                onChange={this.onInvoiceChange}
                                onKeyDown={this.onInvoiceSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-month",
                                }}
                                label={t('SELECT_MONTH')}
                                
                              >
                                {this.state.monthsList.map((a) => (
                                  <option key={a.month} value={a.month}>
                                    {a.month}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div className={classes.searchInputDiv}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "173px" }}
                            >
                              <InputLabel htmlFor="outlined-native-year">
                                {t('SELECT_YEAR')}
                              </InputLabel>

                              <Select
                                native
                                name="year"
                                value={this.state.year}
                                onChange={this.onInvoiceChange}
                                onKeyDown={this.onInvoiceSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-year",
                                }}
                                label={t('SELECT_YEAR')}
                                
                              >
                                {this.state.yearsList.map((a) => (
                                  <option key={a.year} value={a.year}>
                                    {a.year}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div> */}
                          <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                            <Input
                              size="small"
                              variant="outlined"
                              placeholder={t("INVOICE_NO")}
                              value={this.state.invoiceId}
                              name="invoiceId"
                              onChange={this.onInvoiceChange}
                              onKeyDown={this.onInvoiceSearchKeyDown}
                              divClass={classes.inputClass}
                            />
                          </div>
                          <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                            <Input
                              size="small"
                              variant="outlined"
                              placeholder={t("AMOUNT")}
                              value={this.state.invoiceAmount}
                              name="invoiceAmount"
                              // onChange={this.onInvoiceChange}
                              onChange={(e) => {
                                const value = e.target.value
                                  .replace(/[^0-9.]/g, "")
                                  .replace(/(\..*)\./g, "$1");

                                this.setState({ invoiceAmount: value });
                              }}
                              onKeyDown={this.onInvoiceSearchKeyDown}
                              divClass={classes.inputClass}
                            />
                          </div>
                          <div>
                            <TextField
                              name="invoiceFromDate"
                              id="invoiceFromDate"
                              type="date"
                              value={this.state.invoiceFromDate}
                              label={t("FROM_DATE")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant={"outlined"}
                              size={"small"}
                              onChange={this.onInvoiceChange}
                              onKeyDown={this.onInvoiceSearchKeyDown}
                              inputProps={{ max: this.state.today, format: "MM/dd/yyyy" }}
                              style={{ width: '120px' }}
                            // className={classes.dateInputClass}
                            />
                          </div>

                          <div>
                            <TextField
                              name="invoiceToDate"
                              id="invoiceToDate"
                              type="date"
                              value={this.state.invoiceToDate}
                              label={t("TO_DATE")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant={"outlined"}
                              size={"small"}
                              onChange={this.onInvoiceChange}
                              onKeyDown={this.onInvoiceSearchKeyDown}
                              inputProps={{
                                max: this.state.today,
                                min: this.state.invoiceFromDate,
                                format: "MM/dd/yyyy",
                              }}
                              style={{ width: '120px' }}
                            // className={classes.dateInputClass}
                            />
                          </div>
                          <div className={classes.searchInputDiv}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "100px" }}
                            >
                              <InputLabel htmlFor="outlined-native-year">
                                {t('STATUS')}
                              </InputLabel>

                              <Select
                                native
                                name="invoiceStatus"
                                value={this.state.invoiceStatus}
                                onChange={this.onInvoiceChange}
                                onKeyDown={this.onInvoiceSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-invoiceStatus",
                                }}
                                label={t('STATUS')}

                              >
                                <option value={'ALL'}>
                                  {t('ALL')}
                                </option>
                                <option value={'INVOICE_PAID'}>
                                  {t('PAID')}
                                </option>
                                <option value={'INVOICE_READY'}>
                                  {t('UNPAID')}
                                </option>
                              </Select>
                            </FormControl>
                          </div>
                          <div style={{ display: "flex", alignItems: "start" }}>
                            <Tooltip title={t("SEARCH")}>
                              <IconButton className="iconButtonSecondary" onClick={this.filterInvoiceTable}>
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>
                            &nbsp;
                            <Tooltip title={t("CLEAR")}>
                              <IconButton className="iconButtonSecondary" onClick={this.clearInvoiceTableSearch}>
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>
                            &nbsp;
                            <Tooltip title={t("REFRESH")}>
                              <IconButton className="iconButtonSecondary" onClick={this.clearInvoiceTableSearch}>
                                <RefreshIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Card
                      variant="outlined"
                      style={{ borderRadius: "8px", marginTop: "1rem" }}
                    >
                      <div>
                        <TableContainer>
                          <Table style={{ border: 'none' }} className={classes.table + " " + "newGlobalTable" + " " + (this.state.invoiceList && this.state.invoiceList.length > 0 ? 'settlementTableClass' : '')}>
                            <TableHead>
                              <TableRow>
                                {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                                  <TableCell>{t('PARTNER')}</TableCell>
                                }
                                <TableCell className="global-custom-sorting-header" onClick={(e) => { this.updateInvoiceSorting("invoiceId") }}>
                                  {" "}
                                  <b>{t("INVOICE_NO")}</b>
                                  {this.state.invoiceSortBy === "invoiceId" ? (
                                    <span className="material-icons">
                                      {this.state.invoiceSortOrder === "DESC" ? "expand_less" : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                                {/* <TableCell>
                            <b>{t("PAYMENT_MODE")}</b>
                          </TableCell> */}
                                <TableCell className="global-custom-sorting-header" onClick={(e) => { this.updateInvoiceSorting("amount") }}>
                                  {" "}
                                  <b>{t("AMOUNT")}</b>
                                  {this.state.invoiceSortBy === "amount" ? (
                                    <span className="material-icons">
                                      {this.state.invoiceSortOrder === "DESC" ? "expand_less" : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell className="global-custom-sorting-header" onClick={(e) => { this.updateInvoiceSorting("invoiceDate") }}>
                                  {" "}
                                  <b>{t("INVOICE_DATE")}</b>
                                  {this.state.invoiceSortBy === "invoiceDate" ? (
                                    <span className="material-icons">
                                      {this.state.invoiceSortOrder === "DESC" ? "expand_less" : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell className="global-custom-sorting-header" onClick={(e) => { this.updateInvoiceSorting("paidDate") }}>
                                  {" "}
                                  <b>{t("INVOICE_PAID_DATE")}</b>
                                  {this.state.invoiceSortBy === "paidDate" ? (
                                    <span className="material-icons">
                                      {this.state.invoiceSortOrder === "DESC" ? "expand_less" : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell className="global-custom-sorting-header" onClick={(e) => { this.updateInvoiceSorting("statusId") }}>
                                  <b>{t("INVOICE_STATUS")}</b>
                                  {this.state.invoiceSortBy === "statusId" ? (
                                    <span className="material-icons">
                                      {this.state.invoiceSortOrder === "DESC" ? "expand_less" : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell>
                                  <b>{t("ACTIONS")}</b>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.invoiceList.map((row, index) => (
                                <TableRow key={index}>
                                  {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                                    <TableCell>{row.partnerName}</TableCell>
                                  }
                                  <TableCell component="th" scope="row">{row.invoiceId}</TableCell>
                                  {/* <TableCell>
                              {row.paidBy != null ? (
                                <>
                                  {row.paidBy} {row.paidByNumber}
                                </>
                              ) : (
                                <>{t("INVOICED_TO_CUSTOMER")}</>
                              )}
                            </TableCell> */}
                                  <TableCell component="th" scope="row">
                                    {/* {currencyFormatter(
                                      row.totalInvoiceAmount,
                                    )} */}
                                    {currencyFormatter(row.totalInvoiceAmount, null, true)}
                                  </TableCell>
                                  <TableCell component="th" scope="row">{formatDate(row.invoiceDate)}</TableCell>
                                  <TableCell component="th" scope="row">{row.paidDate ? formatDate(row.paidDate) : '-'}</TableCell>
                                  <TableCell component="th" scope="row">
                                    <Chip
                                      size="normal"
                                      className={
                                        row.status === "Paid"
                                          ? "successChip"
                                          : "inProgressChip"
                                      }
                                      label={row.status}
                                    />
                                    {/* {row.status} */}
                                  </TableCell>
                                  <TableCell style={{ whiteSpace: "nowrap" }} component="th" scope="row">
                                    <Tooltip title={t("VIEW")}>
                                      <span style={{ marginRight: 10 }}>
                                        <Button
                                          className={
                                            "buttonSecondary" +
                                            " " +
                                            "iconButtonSecondary"
                                          }
                                          onClick={() => {
                                            this.downloadInvoicePdf(
                                              row.invoiceId,
                                              "view",
                                            );
                                          }}
                                        >
                                          <ViewIconNew />
                                        </Button>
                                      </span>
                                    </Tooltip>
                                    <Tooltip title={t("DOWNLOAD")}>
                                      <span style={{ marginRight: 10 }}>
                                        <Button
                                          className={
                                            "buttonSecondary" +
                                            " " +
                                            "iconButtonSecondary"
                                          }
                                          onClick={() => {
                                            this.downloadInvoicePdf(
                                              row.invoiceId,
                                            );
                                          }}
                                        >
                                          <svg
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M6 1C6.27614 1 6.5 1.22386 6.5 1.5V7.29289L8.64645 5.14645C8.84171 4.95118 9.15829 4.95118 9.35355 5.14645C9.54882 5.34171 9.54882 5.65829 9.35355 5.85355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645C2.84171 4.95118 3.15829 4.95118 3.35355 5.14645L5.5 7.29289V1.5C5.5 1.22386 5.72386 1 6 1ZM1 10.5C1 10.2239 1.22386 10 1.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </Button>
                                      </span>
                                    </Tooltip>
                                    {this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER") && row.status === "Unpaid" && (
                                      <Tooltip title={t("MARK_PAID")}>
                                        <span style={{ marginRight: 10 }}>
                                          <Button
                                            className={
                                              "buttonSecondary" +
                                              " " +
                                              "iconButtonSecondary"
                                            }
                                            onClick={() => {
                                              this.updateInvoiceStatus(
                                                row,
                                              );
                                            }}
                                          >
                                            <InvoicePaid />
                                          </Button>
                                        </span>
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                              {this.state.invoiceList.length === 0 &&
                                <TableRow>
                                  <TableCell colSpan={6} align="center">
                                    {t("NO_RESULT_FOUND")}
                                  </TableCell>
                                </TableRow>
                              }
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {this.state.totalInvoiceCount > 0 && (
                          <div
                            className="global-custom-pagination"
                            style={{ background: "rgba(196, 196, 196, 0.2)" }}
                          >
                            <label style={{ float: "left", padding: "5px" }}>
                              {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalInvoiceCount)}
                            </label>
                            <label>
                              {/* Rows per page select */}
                              {t("ROWS_PER_PAGE")}:
                              <Select
                                value={this.state.invoiceHistoryPerPage}
                                onChange={this.updateInvoiceHistoryPerPageRows}
                              >
                                <MenuItem
                                  value={10}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  10
                                </MenuItem>
                                <MenuItem
                                  value={50}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  50
                                </MenuItem>
                                <MenuItem
                                  value={100}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  100
                                </MenuItem>
                              </Select>
                            </label>
                            {/* Pagination component */}
                            <Pagination
                              page={this.state.invoiceHistoryPage}
                              count={Math.ceil(
                                this.state.totalInvoiceCount /
                                this.state.invoiceHistoryPerPage,
                              )}
                              onChange={this.onInvoiceHistoryPageChange}
                              showFirstButton
                              showLastButton
                            />
                          </div>
                        )}
                      </div>
                    </Card>
                  </div>
                </Paper>
              </>
              : this.state.settlementsView === 'list' ?
                <Paper
                  className={"tablePaper"}
                  elevation={0}
                  style={{ background: "transparent" }}
                >
                  <div className={classes.searchOuterDiv}>
                    {this.props.providerType === "SOLUTION_PROVIDER" && (
                      <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          style={{ width: "173px" }}
                        >
                          <InputLabel htmlFor="outlined-native-tenant">
                            {t('OPCO')}
                          </InputLabel>

                          <Select
                            native
                            name="tenant"
                            value={this.state.tenant}
                            onChange={this.onInvoiceChange}
                            onKeyDown={this.onInvoiceSearchKeyDown}
                            inputProps={{
                              id: "outlined-native-tenant",
                            }}
                            label={t('OPCO')}

                          >
                            {this.state.tenantList.map((a) => (
                              <option key={a.tenantId} value={a.tenantId}>
                                {a.tenantName}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    )}
                    {this.props.providerType === "SALES_CHNL_PROVIDER" && !this.props.tenantRoles.includes("MASTER_PROVIDER") && (
                      <div style={{ paddingRight: 0 }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          style={{ width: "173px" }}
                        >
                          <InputLabel htmlFor="outlined-native-partnerId">
                            {t('PARTNER')}
                          </InputLabel>

                          <Select
                            native
                            name="partnerId"
                            value={this.state.partnerId}
                            onChange={this.onChange}
                            onKeyDown={this.onSearchKeyDown}
                            inputProps={{
                              id: "outlined-native-partnerId",
                            }}
                            label={t('PARTNER')}

                          >
                            <option value={'all'}>
                              {t('ALL')}
                            </option>
                            {this.state.partnerList.map((a) => (
                              <option key={a.id} value={a.id}>
                                {a.groupName}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    )}
                    {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                      this.props.tenantRoles.includes("MASTER_PROVIDER") && this.state.tabValue === 2 && (
                        <>
                          <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "173px" }}
                            >
                              <InputLabel htmlFor="outlined-native-tenant">
                                {t("OPCO")}
                              </InputLabel>

                              <Select
                                native
                                name="tenant"
                                value={this.state.tenant}
                                onChange={this.onChange}
                                onKeyDown={this.onSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-tenant",
                                }}
                                label={t("OPCO")}

                              >
                                {this.state.opcoList.map((a) => (
                                  <option key={a.tenantId} value={a.tenantId}>
                                    {a.tenantName}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "173px" }}
                            >
                              <InputLabel htmlFor="outlined-native-partnerId">
                                {t('PARTNER')}
                              </InputLabel>

                              <Select
                                native
                                name="partnerId"
                                value={this.state.partnerId}
                                onChange={this.onChange}
                                onKeyDown={this.onSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-partnerId",
                                }}
                                label={t('PARTNER')}

                              >
                                <option value={'all'}>
                                  {t('ALL')}
                                </option>
                                {this.state.partnerList.map((a) => (
                                  <option key={a.id} value={a.id}>
                                    {a.groupName}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </>
                      )}

                    {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                      this.props.tenantRoles.includes("MASTER_PROVIDER") && this.state.tabValue === 1 && (
                        <>
                          <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "173px" }}
                            >
                              <InputLabel htmlFor="outlined-native-partnerId">
                                {t('PARTNER')}
                              </InputLabel>

                              <Select
                                native
                                name="partnerId"
                                value={this.state.partnerId}
                                onChange={this.onChange}
                                onKeyDown={this.onSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-partnerId",
                                }}
                                label={t('PARTNER')}

                              >
                                <option value={'all'}>
                                  {t('ALL')}
                                </option>
                                {this.state.partnerList.map((a) => (
                                  <option key={a.id} value={a.id}>
                                    {a.groupName}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div className={classes.searchInputDiv} style={{ paddingRight: 0 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ width: "173px" }}
                            >
                              <InputLabel htmlFor="outlined-native-tenant">
                                {t("OPCO")}
                              </InputLabel>

                              <Select
                                native
                                name="tenant"
                                value={this.state.tenant}
                                onChange={this.onChange}
                                onKeyDown={this.onSearchKeyDown}
                                inputProps={{
                                  id: "outlined-native-tenant",
                                }}
                                label={t("OPCO")}

                              >
                                {this.state.opcoList.map((a) => (
                                  <option key={a.tenantId} value={a.tenantId}>
                                    {a.tenantName}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </>
                      )}
                    <div>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("CUSTOMER_NAME")}
                        value={this.state.customerName}
                        name={"customerName"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        divClass={classes.inputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                    <div>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("ORDER_ID")}
                        value={this.state.orderId}
                        name={"orderId"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        divClass={classes.ordInputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                    <div>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("PRODUCT_NAME")}
                        value={this.state.productName}
                        name={"productName"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        divClass={classes.inputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                    <div>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("INVOICE_NO")}
                        value={this.state.invoiceId}
                        name={"invoiceId"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        divClass={classes.ordInputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                    {/* {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                      <div>
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          placeholder={t("CUSTOMER_BAN")}
                          value={this.state.customerBan}
                          name={"customerBan"}
                          onChange={(e) => {
                            this.onChange(e);
                          }}
                          divClass={classes.inputClass}
                          onKeyDown={(e) => {
                            this.onSearchKeyDown(e);
                          }}
                        />
                      </div>
                    )} */}
                    {/* <div>
                            <Input
                                placeholder="Agent Id"
                                value={this.state.agentId}
                                name={"agentId"}
                                onChange={(e) => { this.onChange(e) }}
                                divClass={classes.agInputClass}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                            />
                        </div> */}
                    <div>
                      <TextField
                        name="fromDate"
                        id="fromDate"
                        type="date"
                        value={this.state.fromDate}
                        label={t("FROM_DATE")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant={"outlined"}
                        size={"small"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        inputProps={{ max: this.state.today, format: "MM/dd/yyyy" }}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                        style={{ width: '120px' }}
                      // className={classes.dateInputClass}
                      />
                    </div>

                    <div>
                      <TextField
                        name="toDate"
                        id="toDate"
                        type="date"
                        value={this.state.toDate}
                        label={t("TO_DATE")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant={"outlined"}
                        size={"small"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        inputProps={{
                          max: this.state.today,
                          min: this.state.fromDate,
                          format: "MM/dd/yyyy",
                        }}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                        style={{ width: '120px' }}
                      // className={classes.dateInputClass}
                      />
                    </div>

                    <div className={classes.searchInputDiv}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        style={{ width: "100x" }}
                      >
                        <InputLabel htmlFor="outlined-native-year">
                          {t('STATUS')}
                        </InputLabel>

                        <Select
                          native
                          name="status"
                          value={this.state.status}
                          onChange={this.onChange}
                          onKeyDown={this.onSearchKeyDown}
                          inputProps={{
                            id: "outlined-native-status",
                          }}
                          label={t('STATUS')}

                        >
                          <option value={'ALL'}>
                            {t('ALL')}
                          </option>
                          <option value={'INVOICE_PAID'}>
                            {t('PAID')}
                          </option>
                          <option value={'INVOICE_READY'}>
                            {t('UNPAID')}
                          </option>
                        </Select>
                      </FormControl>
                    </div>

                    {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <Tooltip title={t("SEARCH")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.filterTable}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("CLEAR")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.clearFilters}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("REFRESH")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.refreshTableSearch}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    {/* </div> */}
                  </div>
                  <SettlementTable
                    list={this.state.settlementList}
                    rowsPerPage={this.state.rowsPerPage}
                    totalSettlementCount={this.state.totalSettlementCount}
                    page={this.state.page}
                    handleChangePage={this.handleChangePage}
                    handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                    sortBy={this.state.sortBy}
                    sortOrder={this.state.sortOrder}
                    updateSorting={this.updateSorting}
                    // convertDate={this.convertDate}
                    isValidDate={isValidDate}
                    providerType={this.props.providerType}
                    tenantRoles={this.props.tenantRoles}
                    tabValue={this.state.tabValue}
                  />
                </Paper>
                : null
          }

          {this.state.showFileData && (
            <Base64ViewerDialog
              base64={this.state.selectedFileToView.base64}
              mimeType={this.state.selectedFileToView.mimeType}
              title={this.state.selectedFileToView.name}
              open={this.state.showFileData}
              onClose={() => {
                this.setState({ selectedFileToView: {}, showFileData: false });
              }}
            />
          )}

          {this.state.showConfirmationDialog && (
            <Dialog
              disableScrollLock={true}
              maxWidth={"sm"}
              PaperComponent={this.draggableDialogPaper}
              fullWidth={true}
              open={this.state.showConfirmationDialog}
              aria-labelledby="delete-dialog-title"
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {t("UPDATE_BILL_STATUS")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => this.closeConfirmDialog(false)}
                      onClick={() => this.closeConfirmDialog(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                  {t("UPDATE_BILL_STATUS_DESCRIPTION")} <b>{this.state.invoiceToUpdate.invoiceId}</b> as paid?<br />
                  <b>{t("AMOUNT")}</b>: {currencyFormatter(this.state.invoiceToUpdate.totalInvoiceAmount)}<br />
                  <b>{t("PARTNER")}:</b> {this.state.invoiceToUpdate.partnerName}<br /><br />
                  <spa style={{ fontWeight: 'bold', fontStyle: 'italic' }}>{t('THIS_ACTION_CANNOT_BE_UNDONE')}</spa>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => this.closeConfirmDialog(false)}
                  color="primary"
                  className="buttonSecondary"
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  onClick={(event) => this.closeConfirmDialog(true)}
                  color="primary"
                >
                  {t("MARK_PAID")}
                </Button>
              </DialogActions>
            </Dialog>
          )}

          <Loader loading={this.state.loading} />
        </main>
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    tenantRoles: state.auth.tenantRoles,
    tenantData: state.auth.tenantData,
    providerId: state.auth.tenantId,
    providerName: state.auth.providerName,
    loggedInUserName: state.auth.loggedInUserName,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Settlement));
